import { render, staticRenderFns } from "./ProductWindow.vue?vue&type=template&id=1900b996&"
import script from "./ProductWindow.vue?vue&type=script&lang=js&"
export * from "./ProductWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports